import { Bug } from 'lucide-react';
import { useDebugLayer } from './DebugLayerProvider';
import { useDebugCapability } from './useDebugCapability';

/**
 * Schwebender Debug-Button (fixed, unten links).
 *
 * Sichtbarkeit ist strikt rollen-gegated über `useDebugCapability`.
 * Normale User sehen weder den Button noch eine Möglichkeit, das Panel
 * über das DOM zu öffnen (das Panel selbst rendert nur, wenn der
 * Button gerendert wurde — siehe `DebugLayerHost`).
 */
export function DebugFloatingButton() {
  const { canUseDebugLayer } = useDebugCapability();
  const { toggle, open, badgeCount, warnErrorCount } = useDebugLayer();

  if (!canUseDebugLayer) return null;

  const hasError = warnErrorCount > 0;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={open ? 'Debug-Panel schliessen' : 'Debug-Panel öffnen'}
      aria-expanded={open}
      data-testid="debug-floating-button"
      className={[
        'fixed bottom-4 left-4 z-[150]',
        'inline-flex items-center justify-center',
        'h-10 w-10 rounded-full',
        'bg-card text-muted-foreground',
        'border border-border/80 shadow-md',
        'transition-colors duration-200',
        'hover:bg-muted hover:text-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60',
        'print:hidden',
      ].join(' ')}
    >
      <Bug className="h-4 w-4" aria-hidden />
      {badgeCount > 0 ? (
        <span
          data-testid="debug-floating-badge"
          className={[
            'absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1',
            'inline-flex items-center justify-center rounded-full',
            'text-[10px] font-semibold leading-none',
            hasError
              ? 'bg-destructive text-destructive-foreground'
              : 'bg-primary text-primary-foreground',
          ].join(' ')}
        >
          {badgeCount}
        </span>
      ) : null}
    </button>
  );
}
